<template>
  <div>
    Error
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
